import Link from 'components/Link'
import PostLayout from 'components/PostLayout'
import { graphql } from 'gatsby'
import React from 'react'
import Layout from '../Layout'
import { SEO } from '../seo'
import { NewsletterForm } from 'components/NewsletterForm'
import CategoryPosts from 'components/CategoryPosts'
import FilteredPosts from 'components/FilteredPosts'

export const Tutorial = ({
    data: {
        allPostsRecent: { edges: allPostsRecent },
        allPostsPopular: { edges: allPostsPopular },
        categories,
    },
}) => {
    return (
        <Layout>
            <SEO title="Tutorials" />

            <PostLayout
                article={false}
                title="Tutorials"
                //  menu={docs}
                hideSidebar
                hideSurvey
            >
                <h1 className="mb-6 mt-0">Tutorials</h1>
                <FilteredPosts allPostsPopular={allPostsPopular} allPostsRecent={allPostsRecent} />
                <NewsletterForm />
                <CategoryPosts categories={categories} />
            </PostLayout>
        </Layout>
    )
}

export default Tutorial

export const TutorialFragment = graphql`
    fragment TutorialFragment on Mdx {
        id
        fields {
            slug
        }
        parent {
            ... on GoogleDocs {
                cover {
                    image {
                        publicURL
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
            }
        }
        frontmatter {
            title
            date
            tags
            category
            Contributor2: authorData2 {
                id
                image {
                    childImageSharp {
                        gatsbyImageData(width: 36, height: 36)
                    }
                }
                name
            }
            Contributor: authorData {
                frontmatter {
                    handle
                    role: jobTitle
                    link_type
                    name
                    link_url
                    image {
                        childrenImageSharp {
                            gatsbyImageData(width: 36, height: 36)
                        }
                    }
                }
                id
                name
                parent {
                    ... on GoogleDocs {
                        cover {
                            image {
                                publicURL
                                childImageSharp {
                                    gatsbyImageData(width: 36, height: 36)
                                }
                            }
                        }
                    }
                }
            }
            featuredImage {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE)
                }
            }
        }
    }
`
